
const actionsTypes = {
    LOADING_DATA_REQUESTED: 'LOADING_DATA_REQUESTED',
    LOADING_DATA_SUCCESS: 'LOADING_DATA_SUCCESS',
    LOADING_DATA_ERROR: 'LOADING_DATA_ERROR',
}

export { actionsTypes }
